import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Redirects non-owner users to /jobs.
 * Returns { isOwner, isLoading } so pages can show a loading state.
 *
 * CST202: introduced to replace `useRequireAdmin` for platform-internal
 * pages (e.g. AdminTranslationsPage). The old hook gated on
 * `role === "admin"` (company-scoped); this one gates on `is_owner`
 * (platform-scoped, backed by OWNER_USER_IDS).
 *
 * Trust boundary: the frontend `is_owner` flag is a UX hint. The backend
 * `credits.require_owner` dependency is the authoritative check.
 */
export function useRequireOwner() {
  const { profile, isLoading } = useAuth();
  const navigate = useNavigate();

  const isOwner = profile?.is_owner === true;

  useEffect(() => {
    if (!isLoading && !isOwner) {
      navigate("/jobs", { replace: true });
    }
  }, [isLoading, isOwner, navigate]);

  return { isOwner, isLoading };
}
